<h1 mat-dialog-title class="notification-title no-select">
	{{ 'mes.incident-code.dialog.delete.header' | translate }}
</h1>
<div mat-dialog-content>
	<p>
		{{ 'mes.incident-code.dialog.delete.content' | translate: { alias: incidentCode.alias } }}
	</p>
</div>
<div mat-dialog-actions>
	<button mat-flat-button color="primary" (click)="onDelete()" (window:keyup.enter)="onDelete()" [disabled]="loading">
		{{ 'mes.incident-code.buttons.okbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" (click)="onCancel()" (window:keyup.escape)="onCancel()">
		{{ 'mes.incident-code.buttons.cancelbtn' | translate }}
	</button>
</div>
